<script>
import { EventBus, Topics, Types } from '@/event-bus'

export default {
  name: 'EpanetRangeBuscaSimulacao',
  props: {
    initialDate: {
      type: Date,
      required: true,
    },
    finalDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
      value: null,
    }
  },
  beforeMount() {
    this.value = this.initialDate
  },
  methods: {
    async emitRange() {
      if (!this.value) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          message: 'Data final não informada',
          type: Types.WARNING,
        })
        return
      }

      if (!(this.value instanceof Date)) {
        this.$emit('value', new Date(this.value))
      } else {
        this.$emit('value', this.value)
      }
    },
  },
}
</script>

<template>
  <div style="height: 60vh; width: 30vw">
    <h1 class="md-title" style="color: black">Buscar simulação</h1>

    <div class="row">
      <div class="col-12">
        <h3 class="md-subheading">Data inicial</h3>
        <VueCtkDateTimePicker
          v-model="value"
          :no-label="true"
          format="YYYY-MM-DD HH:mm"
          formatted="LL"
          :hour-format="24"
          :min-date="initialDate"
          :max-date="finalDate"
        />
      </div>
    </div>

    <div class="mt-2" style="text-align: right">
      <md-button class="md-raised md-accent" @click="$emit('close')">
        Voltar
      </md-button>
      <md-button class="md-primary md-raised" @click="() => emitRange()">
        Buscar
      </md-button>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
